import type { NicType, StringDictionary } from '../types/types';

export const DEFAULT_MIN_PASSWORD_LENGTH = 9;
export const MAX_PASSWORD_LENGTH = 99;
export const DEFAULT_DTC_ACCESS_CODE = 'pivoteclipse';

export const STATES: StringDictionary = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FM: 'Federated States Of Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  MP: 'Northern Mariana Islands',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PW: 'Palau',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const ADDICTION_TYPES: StringDictionary = {
  SMOKING: 'cig',
  CHEWING: 'chew',
  VAPING: 'vape',
  OTHER: 'other',
  NONE: 'none',
};

export const ADDICTION_TYPES_URL_PARAM: Record<NicType, string[]> = {
  cig: [ADDICTION_TYPES.SMOKING],
  chew: [ADDICTION_TYPES.CHEWING],
  vape: [ADDICTION_TYPES.VAPING],
  other: [ADDICTION_TYPES.OTHER],
  'cig-other': [ADDICTION_TYPES.SMOKING, ADDICTION_TYPES.OTHER],
};

export const USER_EMAIL_STATUS_RES: StringDictionary = {
  EXISTS: 'user-exists',
  NOT_VERIFIED: 'email-not-verified',
  NOT_FOUND: 'user-not-found',
  NOT_INITIALIZED: 'user-not-initialized',
  INVALID_EMAIL: 'invalid-email',
  UNDEFINED: 'undefined',
};
